import { render, staticRenderFns } from "./TagCard.vue?vue&type=template&id=75c6f611&scoped=true&"
import script from "./TagCard.vue?vue&type=script&lang=js&"
export * from "./TagCard.vue?vue&type=script&lang=js&"
import style0 from "./TagCard.vue?vue&type=style&index=0&id=75c6f611&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c6f611",
  null
  
)

export default component.exports